import React, { useMemo, useState } from 'react';

import downloadViaIframe from '../../utils/downloadViaIframe';

const MONTHS = [
	'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
	'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

const MIN_YEAR = 2026;
const MIN_MONTH = 1;

const NBA_REPORT_URL = 'https://us-central1-gepp-300009.cloudfunctions.net/Download_reporte_NBA';

const NBA = () => {
	const now = useMemo(() => new Date(), []);
	const maxYear = now.getFullYear();
	const maxMonth = now.getMonth();

	const [year, setYear] = useState(maxYear);
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [showToast, setShowToast] = useState(false);

	const isMonthDisabled = (idx) => {
		if (year === maxYear && idx > maxMonth) return true;
		if (year === MIN_YEAR && idx < MIN_MONTH) return true;
		return false;
	}

	const handleSelectMonth = (idx) => {
		if (isMonthDisabled(idx)) return;
		setSelectedMonth(idx);
	}

	const handleDownload = () => {
		if (selectedMonth === null) return;

		const monthAbbr = MONTHS[selectedMonth].slice(0, 3);
		const url = `${NBA_REPORT_URL}?month=${monthAbbr}&year=${year}`;

		downloadViaIframe(url);

		setShowToast(true);
		setTimeout(() => setShowToast(false), 5000);
	}

	const selectionVisible = selectedMonth !== null;
	const selectedLabel = selectedMonth !== null
		? `${MONTHS[selectedMonth]} ${year}`
		: '—';

	return (
		<div className='m-3 pb-5'>
			<h2 className='text-center'>NBA</h2>
			<div className='container py-2 py-md-3' style={{ maxWidth: '780px' }}>
				<div className='nba-panel-card'>
					<div className='nba-panel-header'>
						<h4>Descargar reporte mensual</h4>
						<p>Elige el periodo y genera el archivo para exportar.</p>
					</div>
					<div className='nba-panel-body'>
						<label className='nba-field-label'>Periodo</label>
						<div className='nba-year-switcher'>
							<button type='button' onClick={() => setYear(y => y - 1)} disabled={year <= MIN_YEAR} aria-label='Año anterior'>
								<i className='bi bi-chevron-left' />
							</button>
							<span className='nba-year-label'>{year}</span>
							<button type='button' onClick={() => setYear(y => y + 1)} disabled={year >= maxYear} aria-label='Año siguiente'>
								<i className='bi bi-chevron-right' />
							</button>
						</div>
						<div className='nba-month-grid'>
							{MONTHS.map((name, idx) => {
								const disabled = isMonthDisabled(idx);
								const selected = selectedMonth === idx;
								return (
									<button
										key={name}
										type='button'
										className={`nba-month-chip${selected ? ' selected' : ''}`}
										disabled={disabled}
										title={name}
										onClick={() => handleSelectMonth(idx)}
									>
										{name.slice(0, 3)}
									</button>
								);
							})}
						</div>

						<div className={`nba-selection-row${selectionVisible ? ' visible' : ''}`}>
							<div>
								<div className='nba-selection-label'>Mes seleccionado</div>
								<div className='nba-selection-value'>{selectedLabel}</div>
							</div>
							<button
								type='button'
								className='btn nba-btn-download'
								onClick={handleDownload}
							>
								<i className='bi bi-download' />
								<span>Descargar reporte</span>
							</button>
						</div>
					</div>
				</div>
			</div>

			<div className={`app-toast${showToast ? ' show' : ''}`}>
				<i className='bi bi-info-circle-fill' />
				<span>Descarga en proceso. Aparecerá en tu barra de descargas cuando esté lista.</span>
			</div>
		</div>
	);
}

export default NBA;
